import { isNullOrUndefined } from "@qntm-code/utils";
export class LedgerAccountInfo {
  ledgerAccountId: number;
  accountId: number;
  accountNumber: number;
  accountName: string;
  accountDescription: string;

  constructor (ledgerAccountId?: number, accountName?: string, accountNumber?: number) {
    if (!isNullOrUndefined(ledgerAccountId)) {
      this.ledgerAccountId = ledgerAccountId;
    }
    if (!isNullOrUndefined(accountName)) {
      this.accountName = accountName;
    }
    if (!isNullOrUndefined(accountNumber)) {
      this.accountNumber = accountNumber;
    }
  }
}
